import { render } from "./collection-retry-detail.vue?vue&type=template&id=2b5c4bc2"
import script from "./collection-retry-detail.vue?vue&type=script&lang=js"
export * from "./collection-retry-detail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__